export enum Sex {
  MALE = 'male',
  FEMALE = 'female',
}
